<template>
    <div>
        <v-breadcrumbs :items="crumbs" divider="/" style="background-color: #f0f0f0">
        </v-breadcrumbs>
        <v-card class="mx-auto" outlined tile color="#F8F8FF">
        <v-card-title>Users</v-card-title>
        <v-container class="fill-height"
        fluid>
            <v-row>
                <v-btn-toggle class="col-12 col-md-6 offset-md-6" style="background: none">
                    <v-btn small disabled>
                        <v-icon small>fa fa-search</v-icon>
                    </v-btn>
                    <v-text-field placeholder="Search" class="search-textfield" hide-details outlined dense v-model="search"></v-text-field>
                </v-btn-toggle>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items.sync="items"
                        hide-default-footer
                        :loading="tableloading"
                        :search="search"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>{{props.item.userID}}</td>
                            <td>
                                <!--
                                <v-tooltip top v-if="validateAccess('user_add')">
                                <template v-slot:activator="{ on }">
                                <span>{{props.item.email}}
                                    <a v-on="on" id="custom-hover" @click.prevent="viewMore(props.item, 'reset')"><v-icon color="blue" right x-small>fa fa-redo</v-icon></a>
                                </span>
                                </template>
                                <span>Reset User</span>
                                </v-tooltip>
                                -->
                                <span>{{props.item.email}}</span>
                            </td>
                            <td>{{props.item.mobile}}</td>
                            <td>
                                <tr style="background: none">
                                    <td style="border: none">
                                        <v-tooltip top v-if="validateAccess('customer_add_profile')">
                                        <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" color="blue" icon x-small @click.prevent="viewMore(props.item, 'add')"><v-icon class="custom-hover" color="blue" x-small>fa fa-plus</v-icon></v-btn>
                                        </template>
                                        <span>Add Profile</span>
                                        </v-tooltip>
                                    </td>
                                    <td style="border: none">
                                        <span v-for="(it, id) in props.item.typeRoleName" :key="id"><v-chip style="height: unset" v-html="`Type: ${it.typeN} <br/> Role: ${it.roleN} <br/> Operator: ${it.operator} <br/> Carpark: ${it.carpark}`" x-small class="ma-1" color="blue" text-color="white"></v-chip><v-btn color="red" v-if="validateAccess('customer_remove_profile')" icon x-small @click.prevent="viewDelete(props.item, it, 'delete')"><v-icon class="custom-hover" color="red" x-small>fa fa-trash</v-icon></v-btn><br/></span>
                                    </td>
                                </tr>
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        </v-card>
        <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
        </v-snackbar>
        <alert :dialog="ma.modal_status" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alert>
        <alertbox2 :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox2>
        <alertdelete :dialog="ma.modal_delete" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :item="ma.item" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></alertdelete>
        <addprofile :dialog="ma.modal_profile" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></addprofile>
    </div>
</template>
<script>
import timer from '../../assets/js/sleeper';
import alert from '.././modals/AlertStatus';
import {ERR} from '../../assets/js/errhandle.js';
import alertbox2 from '../modals/Notification';
import alertdelete from '../modals/AlertDeleteProfile';
import addprofile from '.././modals/CreateProfileExistingCustomer';
import {rule} from '../../assets/js/checkPerm';

export default {
    name: 'Users',
    title: 'Users',
    
    data()  {
        return {
            crumbs: [
                {
                text: 'Home',
                disabled: true,
                href: '#',
                },

                {
                text: 'Users',
                disabled: true,
                href: '#',
                },
            ],
            items: [],
            search: '',
            headers: [
                { text: '#', value: 'row', width: '3%' },
                { text: 'User ID', value: 'userID', width: '3%' },
                { text: 'Email', value: 'email', width: '15%' },
                { text: 'Mobile', value: 'mobile', width: '15%' },
               // { text: 'Role ID', value: 'role', width: '15%' },
               // { text: 'Type Name', value: 'typeName', width: '15%' },
               // { text: 'Role Name', value: 'roleName', width: '15%' },
               // { text: 'Type ID', value: 'type', width: '15%' },
                { text: 'Profile', value: 'typeRoleName', width: '25%' },
            ],
            tableloading: false,
            btn_loading: false,
            pages: 0,
            page: 1,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                confirmCreate: false,

                modal_status: false,
                modal_update: false,
                modal_delete: false,
                modal_profile: false,
                readonly: true,
                allInfo: [],
                item: {}
            },

            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },

            services: [],
            dropitems: {}
        }
    },

    components: {alert, alertbox2, alertdelete, addprofile},

    async created(){
        this.getUsers();
    },

    methods: {
        async getUsers(){
            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("getCustomers", {});
                let response2 = await this.$store.dispatch('getCustomerTypeRole', {});
                let response3 = await this.$store.dispatch("getAllOperator", {search: ''});
                let response4 = await this.$store.dispatch("getAllCarpark2", {});

                this.services = response;
                await timer.sleep(100);
                if (response.data.code == 'AP000' && response2.data.code == 'AP000' && response3.data.code == 'AP000' && response4.data.code == 'AP000'){
                let dt = response.data.record;
                let dt2 = response2.data.record;
                let dt3 = response3.data.record;
                let dt4 = response4.data.record;

                let recordCount = response.data.count;

                for(var i=0; i<dt2.length; i++){
                    for(var j=0; j<dt3.length; j++){
                        if (dt2[i].Operator == dt3[j].OperatorID){
                            dt2[i].operatorName = dt3[j].OperatorName;
                            dt2[i].OperatorID = dt3[j].OperatorID;
                        }

                        else if (dt2[i].Operator == '4ALLOP'){
                            dt2[i].operatorName = 'ALL';
                            dt2[i].OperatorID = '4ALLOP';
                        }
                    }
                }

                for(var i=0; i<dt2.length; i++){
                    for(var j=0; j<dt4.length; j++){
                        if (dt2[i].Carpark == dt4[j].CarParkID){
                            dt2[i].carparkName = dt4[j].CarParkName;
                            dt2[i].CarParkID = dt4[j].CarParkID;
                        }

                        else if (dt2[i].Carpark == '4ALLCP'){
                            dt2[i].carparkName = 'ALL';
                            dt2[i].CarParkID = '4ALLCP';
                        }
                    }
                }

                let response5 = await this.$store.dispatch("listProfileTypeCustomer", {search: ''});
                let response6 = await this.$store.dispatch("listProfileRoleCustomer", {search: ''});
                let dt5 = response5.data.record;
                let dt6 = response6.data.record;
                
                for(var i=0; i<dt2.length; i++){
                    for(var j=0; j<dt5.length; j++){
                        if (dt2[i].Type == dt5[j].ID){
                            dt2[i].typeName = dt5[j].TypeName;
                        }
                    }
                }

                for(var i=0; i<dt2.length; i++){
                    for(var j=0; j<dt6.length; j++){
                        if (dt2[i].Role == dt6[j].ID){
                            dt2[i].roleName = dt6[j].RoleName;
                        }
                    }
                }

                for(var i=0; i<dt.length; i++){
                    dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                    let type = []; let role = []; let typeName = []; let roleName = []; let typeRoleName = [];

                    for(var j=0; j<dt2.length; j++){
                        if (dt[i].userID == dt2[j].userID){
                           if (dt2[j].Role == dt[i].Role){
                                roleName.push(dt[i].Role_Name);
                           }

                           typeRoleName.push({typeID: dt2[j].Type, typeN: dt2[j].typeName, roleID: dt2[j].Role, roleN: dt2[j].roleName, operatorID: dt2[j].OperatorID, operator: dt2[j].operatorName, carparkID: dt2[j].CarParkID, carpark: dt2[j].carparkName}); dt[i].typeRoleName = typeRoleName;
                        }
                    }
                }

                //remove duplicate id from object array
                const uniqueAddresses = Array.from(new Set(dt.map(a => a.userID)))
                .map(id => {
                return dt.find(a => a.userID === id)
                });

                for(var i=0; i<uniqueAddresses.length; i++){
                    uniqueAddresses[i].mobile = uniqueAddresses[i].mobile == null ? "N/A" : uniqueAddresses[i].mobile;
                    uniqueAddresses[i].email = uniqueAddresses[i].email == null ? "N/A" : uniqueAddresses[i].email;
                }

                let uniqueAddresses2 = uniqueAddresses.filter(i => i.userID !== 0); //remove userid = 0

                this.items = uniqueAddresses2;
                this.pages = Math.ceil(recordCount / 100);
                this.tableloading = false;

                this.dropitems.operator = dt3;
                this.dropitems.carpark = dt4;
                this.dropitems.profiletype = dt5;
                this.dropitems.profilerole = dt6;
                }
            }

            catch(err){
                console.log(err);
            }
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        async addUser(v){
            this.btn_loading = true;
            this.tableloading = true;

            try{
                this.swal.scolor = 'green';
                let req = {email: v[0].email};
                let response = await this.$store.dispatch("userRegister", req);
                await timer.sleep(800);
                if (response.data.code === 'AP000'){
                    let response2 = await this.$store.dispatch("userReset", req);
                    if (response2.data.code === 'AP000'){
                        await this.getUsers();
                        this.add(v);
                        this.ex.modal = true;
                        this.ex.content.headline = 'Email Registered!';
                        this.ex.content.icon = 'fa fa-check';
                        this.ex.content.chipColor = '#a0e8af';
                        this.ex.content.iconColor = 'green';
                        this.ex.content.maintext = 'Please inform user of this email to check their inbox/junk mail for verification link.';
                        this.ex.content.smalltext = 'If verification link is expired, please reset the same email again.';

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Email Registered!`;
                    }
                }
                else if (response.data.code === 'RD002'){
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: This email is already registered`;
                }

                else{
                    this.tableloading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
                this.btn_loading = false;
            }

            catch(err){
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = ERR.HANDLE(response.data.code);
            }

            /*
            try{
                this.swal.scolor = 'green';
                let req = {email: v[0].email};
                let response = await this.$store.dispatch("userRegister", req);
                await timer.sleep(800);
                if (response.data.code === 'AP000'){
                    let response2 = await this.$store.dispatch("userReset", req);
                    if (response2.data.code === 'AP000'){
                        await this.getUsers();
                        this.ex.modal = true;
                        this.ex.content.headline = 'Email Registered!';
                        this.ex.content.icon = 'fa fa-check';
                        this.ex.content.chipColor = '#a0e8af';
                        this.ex.content.iconColor = 'green';
                        this.ex.content.maintext = 'Please inform user of this email to check their inbox/junk mail for verification link.';
                        this.ex.content.smalltext = 'If verification link is expired, please reset the same email again.';

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Email Registered!`;
                    }
                }
                else if (response.data.code === 'RD002'){
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: This email is already registered`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
                this.btn_loading = false;
            }

            catch(err){
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = ERR.HANDLE(response.data.code);
            }
            */
        },

        async add(v){
            this.btn_loading = true;
            this.tableloading = true;

            let loop = v[1].selected.length;

            for(let i=0; i<loop; i++){
                try{
                    this.swal.scolor = 'green';
                    let req = {userid: this.items[this.items.length - 1].userID, type: v[2].selected, role: v[1].selected[i].ID};

                    let response = await this.$store.dispatch("createProfile", req);
                    await timer.sleep(800);
                    if (response.data.code === 'AP000'){
                            await this.getUsers();
                            this.swal.notification = true;
                            this.swal.scolor = 'green';
                            this.swal.message = `${ERR.HANDLE(response.data.code)}: Profile Created!`;
                    }

                    else if (response.data.code === 'RD002'){
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: This profile already exists`;
                    }

                    else{
                        this.tableloading = false;
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                    }

                    this.tableloading = false;
                    this.btn_loading = false;
                }

                catch(err){
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = ERR.HANDLE(response.data.code);
                }
            }
        },

        async userReset(){
            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("userReset", {email: this.ma.modalInfo.email})
                if (response.data.code === 'AP000'){
                        await this.getUsers();
                        this.ex.modal = true;
                        this.ex.content.headline = 'Email Reset!';
                        this.ex.content.icon = 'fa fa-check';
                        this.ex.content.chipColor = '#a0e8af';
                        this.ex.content.iconColor = 'green';
                        this.ex.content.maintext = 'Please inform user of this email to check their inbox/junk mail for verification link.';
                        this.ex.content.smalltext = 'If verification link is expired, please reset the same email again.';

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Email has been reset!`;
                }

                else{
                    this.tableloading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async deleteProfile(){
            try{
                this.tableloading = true;
                let req = {loginemailid: this.ma.modalInfo.loginEmailID, type: this.ma.item.typeID, role: this.ma.item.roleID, operator: this.ma.item.operatorID, carpark: this.ma.item.carparkID};
                let response = await this.$store.dispatch("deleteProfileCustomer", req)
                if (response.data.code === 'AP000'){
                        await this.getUsers();
                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Profile has been deleted!`;
                }

                else{
                    this.tableloading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async addProfileExistingUser(v){
            this.btn_loading = true;
            this.tableloading = true;

            try{
                //this.swal.scolor = 'green';
                let req = {loginemailid: this.ma.modalInfo.loginEmailID, type: v[2].selected, role: v[3].selected, operator: v[4].selected, carpark: v[5].selected};

                let response = await this.$store.dispatch("createProfileCustomer", req);
                await timer.sleep(800);
                if (response.data.code === 'AP000'){
                        await this.getUsers();
                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Profile Created!`;
                }

                else if (response.data.code === 'RD002'){
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: This profile already exists`;
                }

                else{
                    this.tableloading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
                this.btn_loading = false;
            }

            catch(err){
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = ERR.HANDLE(response.data.code);
            }
        },

        viewMore(row, flag){
            //this.autoRefresh = 0;
            if (flag == 'reset'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
            }

            if (flag == 'create'){
                this.ma.modal = true;
                this.ma.allInfo = this.items;
            }

            if (flag == 'add'){
                this.ma.modal_profile = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.dropitems;
            }

            this.ma.customText = {text1: "Gate ID", text2: "Name"};
            this.ma.modal_action_type = flag;
        },

        viewDelete(row, it, flag){
            if (flag == 'delete'){
                this.ma.modal_delete = true;
                this.ma.modalInfo = row;
                this.ma.item = it;
            }

            this.ma.modal_action_type = flag;
        },

        viewProfile(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Admin Profile", params: {id: row.userID}, query: {email: row.email}});
        },

        onClosed(value){
            if (value == false){
                this.ma.modal = value;
                this.ma.modal_status = value;
                this.ma.modal_update = value;
                this.ma.modal_delete = value;
                this.ma.modal_profile = value;
                this.ex.modal = value;
            }
        },

        onConfirm(value){
            if (value.flag === 'add'){
                this.ma.modal_profile = false;
                this.addProfileExistingUser(value);
            }

            if (value === true){
                if (this.ma.modal_action_type == 'reset')
                {
                    this.ma.modal_status = false;
                    this.userReset();
                }

                if (this.ma.modal_action_type == 'delete')
                {
                    this.ma.modal_delete = false;
                    this.deleteProfile();
                }
            }
        },

        searchTimeOut() {

          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          this.getUsers();
          }, 800);
        },

        validateArr(arr){
            let truth = arr.some(item => {
                return item === true;
            });

            return truth;
        },
    }
}
</script>